import { useWorkflow } from '../context/WorkflowContext';
import { TNodeProps } from '../types/node';
import { BaseNode } from './BaseNode';
import { StandardHandles } from './StandardHandles';

export const StartNode = (props: TNodeProps) => {
  const { workflow } = useWorkflow();
  const { data } = props;
  const canAddOutgoing = !workflow?.stepTransitions?.some(
    (transition) => transition.fromStepId === data.id
  );

  return (
    <BaseNode {...props}>
      <StandardHandles isSourceConnectable={canAddOutgoing} />
    </BaseNode>
  );
};
